export const EMPTY_VALUE_DASH = '\u2014'
